import { getWorkoutsDayUtil } from 'modules/day/utils/getWorkouts/index.js'

export const hasWorkoutsDayUtil = day => {
  return getWorkoutsDayUtil(day)?.length > 0
}
